const KO_AUTO_CAMPAIGN_TYPES = ["Search", "Shopping"];
const KO_AUTO_BIDDING_STRATEGIES = ["Target ROAS", "Maximize Conversion Value"];

/** Whether a campaign row can get a KO Bidding Auto activation (Campaigns tab). */
export const isEligibleForKoAuto = (row: any): boolean =>
    KO_AUTO_CAMPAIGN_TYPES.includes(row?.campaign_type) &&
    KO_AUTO_BIDDING_STRATEGIES.includes(row?.bidding_strategy_type);
